import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { it } from 'date-fns/locale';
import type { ReactNode } from 'react';

interface DatePickerProviderProps {
  children: ReactNode;
}

/**
 * Provider per i componenti Date Picker di MUI.
 * Configura l'adapter date-fns con locale italiano.
 */
export function DatePickerProvider({ children }: DatePickerProviderProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={it}>
      {children}
    </LocalizationProvider>
  );
}
